import React, { FC, useEffect } from 'react';
import './HomePage.css';

import {
	NewLayout,
	BirthDateWidget,
	GenricDomainStack,
	useBreakPoint,
	uiStateActions,
	ActionStatusHelper,
	PageLoader,
	Alert,
	FeedBackType,
} from '@/Shared';
import { useAppDispatch, usePermission } from '@/OneLiners';
import { PlanningWidget } from '@/Domains/Planning/UI';

interface HomePageProps { }

const HomePage: FC<HomePageProps> = () => {

	const { isDesktop, isMobile } = useBreakPoint();
	const {stateResponse} = usePermission();
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(uiStateActions.setPageTitle(null));
		dispatch(uiStateActions.setTotalItems(null));
	}, [dispatch]);

	if (ActionStatusHelper.isFailed(stateResponse.status)) {
		return <Alert data = {{ title : "Accueil - Erreur",
			message : "Une erreur est survenu lors du chargement des permissions. Veuillez réessayer. Merci.",
			type : FeedBackType.ERROR
		}} />;
	}

	if (!ActionStatusHelper.isSucceeded(stateResponse.status)) {
		return <PageLoader message="[Accueil] - Chargement des permission en cours. Veuillez patienter. Merci" />;
	}

	return (
		<div className="HomePage HomePage__widget-box">
			<div className='widget-group'>
				<NewLayout />
				{
					isDesktop && (
						<GenricDomainStack
							allowAll={false}
							homeMode={true}
							format='List'
						/>
					)
				}
			</div>
			<div className='widget-group'>
				{isDesktop && <PlanningWidget />}
				<BirthDateWidget />
			</div>
		</div>
	);
}

export default HomePage;
